import XLSX from 'xlsx';

export function read(file) {
  const reader = new FileReader();
  return new Promise(async (resolve, reject) => {
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, {type: 'array'});
      let sheetName = workbook.SheetNames[0];
      let sheet = workbook.Sheets[sheetName];
      let result = {
        columns: []
      };
      result.rows = XLSX.utils.sheet_to_json(sheet);
      result.rows.forEach(row => {
        Object.keys(row).forEach(key => {
          if (!result.columns.includes(key)) {
            result.columns.push(key);
          }
        })
      });
      
      resolve(result);
    };

    reader.onerror = () => {
      reader.abort();
      reject('Problem parsing input file.');
    }

    reader.readAsArrayBuffer(file); 
  });  
}